import React from "react";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    initials: "TB",
    name: "Tati Bueno",
    role: "Funcionária pública · Mogi das Cruzes",
    text: "Em apenas 3 meses, o Dr. Guilherme transformou meus resultados de forma mais expressiva do que em 8 anos de treinos. Sem fórmulas mágicas — acompanhamento individualizado, alinhando dieta, protocolo hormonal e exames constantes, sempre com foco na minha saúde. Estamos apenas começando!",
  },
  {
    initials: "IN",
    name: "Ismael Nogueira",
    role: "Publicitário · São Paulo",
    text: "Finalmente encontrei um médico que me ouviu de verdade. A abordagem preventiva e personalizada da AEVOS é diferente de tudo que já vi. Hoje consigo treinar melhor, dormir melhor e o rendimento no trabalho melhorou muito.",
  },
  {
    initials: "CM",
    name: "Chrys Moura",
    role: "Enfermeira · Mogi das Cruzes",
    text: "Excelente acompanhamento. Sua dedicação, orientação e profissionalismo foram fundamentais para a melhora da minha performance, redução do percentual de gordura e ganho de massa magra. Os resultados alcançados refletem a qualidade do seu trabalho e o cuidado individualizado com seus pacientes. Muito obrigada por todo o suporte e incentivo durante essa jornada!",
  },
];

const Testimonials = () => {
  return (
    <section className="pt-4 md:pt-6 pb-16 md:pb-24" data-testid="home-testimonials">
      <div className="aevos-container">
        <div className="text-center max-w-2xl mx-auto">
          <span className="aevos-eyebrow">
            Quem já transformou
          </span>
          <h2 className="font-display font-bold text-4xl md:text-5xl text-black mt-5 leading-[1.05]">
            Depoimentos
          </h2>
          <p className="mt-4 text-[#333333] text-base">
            Histórias reais de pessoas que escolheram viver com mais saúde e propósito.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.name}
              className="aevos-card p-7 flex flex-col"
              data-testid={`testimonial-${i}`}
            >
              <div className="flex gap-1 mb-5">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star
                    key={s}
                    size={18}
                    className="text-[#00C4FF]"
                    fill="#00C4FF"
                    strokeWidth={0}
                  />
                ))}
              </div>

              <p className="text-[#333333] italic text-[0.95rem] leading-relaxed flex-1 relative">
                <span className="text-[#00C4FF] font-display text-2xl leading-none mr-1 align-top">
                  &ldquo;
                </span>
                {t.text}
                <span className="text-[#00C4FF] font-display text-2xl leading-none ml-1 align-bottom">
                  &rdquo;
                </span>
              </p>

              <div className="mt-7 pt-5 border-t border-[#E0E0E0] flex items-center gap-4">
                <div
                  className="w-12 h-12 bg-[#00C4FF] flex items-center justify-center font-display font-bold text-black text-sm tracking-wider flex-shrink-0"
                  aria-hidden="true"
                >
                  {t.initials}
                </div>
                <div>
                  <p className="font-display font-semibold text-black text-sm">{t.name}</p>
                  <p className="text-xs text-[#666] mt-0.5">{t.role}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
